import React, { useState } from "react";
import { FaArrowCircleLeft, FaMoneyBill, FaReceipt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

import CustomButton from "../../shared/CustomButton";
import { VisitTabs } from "../../constants/VisitsConstants";
import CustomTabs from "../../shared/CustomTabs";
import CustomChip from "../../shared/CustomChip";
import PayVisitBillForm from "../../components/his/visits/PayVisitBillForm";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import DepositForm from "./depost/DepositForm";
import WithdrawDepositForm from "./depost/WithdrawDepositForm";
import PayCreditForm from "./depost/PayCreditForm";
import ReusableModal from "../../shared/ReuseableModal";
import CreateVisitForm from "../../components/his/visits/CreateVisitForm";

const CreateVisit = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const billingVisitData = state?.billingVisitData || null;
  const [category, setCategory] = useState("out_patient");
  const [openDepositForm, setOpenDepositForm] = useState(false);
  const [openWithdrawForm, setOpenWithdrawForm] = useState(false);
  const [eligibilityData, setEligibilityData] = useState(null);
  const [openPayCreditForm, setOpenPayCreditForm] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [refreshDepositTrigger, setRefreshDepositTrigger] = useState(0);
  const [refreshCreditTrigger, setRefreshCreditTrigger] = useState(0);
  const { t } = useTranslation();
  const [selectedPatient, setSelectedPatient] = useState(
    location?.state?.selectedPatient || state?.patient
    || ""
  );


  const [withoutSlot, setWithoutSlot] = useState(false);
  return (
    <div className="main-page-container !overflow-y-auto scrollbar !py-0">
      <div className="w-full">
        {billingVisitData ? (
          <PayVisitBillForm
            showComments={showComments}
            setShowComments={setShowComments}
            setOpenPayCreditForm={setOpenPayCreditForm}
            setOpenDepositForm={setOpenDepositForm}
            setOpenWithdrawForm={setOpenWithdrawForm}
            setSelectedPatient={setSelectedPatient}
            selectedPatient={selectedPatient}
            refreshCreditTrigger={refreshCreditTrigger}
          />
        ) : (
          // <CustomTabs
          //   setCategory={setCategory}
          //   tabs={VisitTabs(
          //     t,
          //     setEligibilityData,
          //     setSelectedPatient,
          //     selectedPatient,
          //     state,
          //     openDepositForm,
          //     withoutSlot,
          //     refreshDepositTrigger,
          //     refreshCreditTrigger
          //   )}
          //   activeTabIndex={
          //     state?.tab
          //       ? state?.tab == "outpatient" || state?.tab == "out_patient"
          //         ? 0
          //         : 1
          //       : 0
          //   }
          // />
          <CreateVisitForm
            showComments={showComments}
            eligibilityData={eligibilityData}
            setShowComments={setShowComments}
            openPayCreditForm={openPayCreditForm}
            setOpenPayCreditForm={setOpenPayCreditForm}
            openDepositForm={openDepositForm}
            setOpenDepositForm={setOpenDepositForm}
            openWithdrawForm={openWithdrawForm}
            setOpenWithdrawForm={setOpenWithdrawForm}
            selectedPatient={selectedPatient}
            visit_category="out_patient"
            setEligibilityData={setEligibilityData}
            setSelectedPatient={setSelectedPatient}
            refreshDepositTrigger={refreshDepositTrigger}
            refreshCreditTrigger={refreshCreditTrigger}
          />
        )}
        <ReusableModal
          title={`${t("Deposit Form")}`}
          isVisible={openDepositForm}
          HeaderIcon={FaMoneyBill}
          position="top"
          onClose={() => {
            setOpenDepositForm(false);
          }}
        >
          <DepositForm
            selectedPatient={selectedPatient}
            setOpenDepositForm={setOpenDepositForm}
            state={state}
            onDepositSuccess={() => setRefreshDepositTrigger(prev => prev + 1)}
          />
        </ReusableModal>
        <ReusableModal
          title={`${t("Withdraw Deposit")}`}
          isVisible={openWithdrawForm}
          HeaderIcon={FaMoneyBill}
          position="top"
          onClose={() => {
            setOpenWithdrawForm(false);
          }}
        >
          <WithdrawDepositForm
            selectedPatient={selectedPatient}
            setOpenWithdrawForm={setOpenWithdrawForm}
            onWithdrawSuccess={() => setRefreshDepositTrigger(prev => prev + 1)}
            withOutSlot={withoutSlot}
            state={state}
          />
        </ReusableModal>
        <ReusableModal
          title={`${t("Pay Credit")}`}
          isVisible={openPayCreditForm}
          HeaderIcon={FaMoneyBill}
          position="top"
          onClose={() => {
            setOpenPayCreditForm(false);
          }}
        >
          <PayCreditForm
            selectedPatient={selectedPatient}
            setOpenPayCreditForm={setOpenPayCreditForm}
            state={state}
            onPayCreditSuccess={() => setRefreshCreditTrigger(prev => prev + 1)}
            withOutSlot={withoutSlot}
          />
        </ReusableModal>
      </div>
    </div>
  );
};

export const EligibilityDataComponent = ({
  eligibilityData,
  referralEligible = false
}) => {
  let siteEligibility =
    eligibilityData?.nphies_entries?.CovElgResp?.resource?.extension?.[0]
      ?.valueCodeableConcept?.coding?.[0]?.code;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start min-w-0 w-full">
      <label className="input-label block mb-1 uppercase text-[10px] md:text-[11px] whitespace-nowrap">
        {t("eligibility")}
      </label>
      <CustomChip
        label={referralEligible ? t("eligible") : siteEligibility || ""}
        className="h-[30px] px-3 w-full rounded-md whitespace-nowrap text-[11px] md:text-[13px] font-bold truncate min-w-0 flex items-center justify-center"
        chipType={referralEligible || siteEligibility == "eligible" ? "success" : (eligibilityData?.nphies_status == 'error' ||
          siteEligibility === 'not-active') ? "danger" : "default"}
      />
    </div>
  );
};

export default CreateVisit;
